import axios from 'axios'
import router from '../../router'
export default {
  checkEmail ({state, commit}, token) {
    return new Promise((resolve, reject) => {
      if (state.email === '') {
        commit('toastr', {
          color: 'info',
          texto: 'Insira um email'
        })
        reject()
      } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(state.email)) {
        commit('toastr', {
          color: 'info',
          texto: 'Insira um email valido'
        })
        reject()
      } else {
        commit('toggleLoadingEmail', true)
        axios({
          method: 'get',
          url: process.url + 'Hotsite/VerifyUser?email=' + state.email,
          timeout: 200000,
          headers: {
            'Token': token
          }
        })
        .then((response) => {
          commit('toggleLoadingEmail', false)
          if (response.data.resultado.haveAccess) {
            router.push('/a/Confirmar')
          } else {
            commit('toastr', {
              color: 'info',
              texto: 'Não foi encontrado seu email na base de dados'
            })
          }
        })
        .catch((error) => {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros
            var description = ''
            if (erros.length > 0) {
              erros.forEach(element => {
                description = description + ' ' + element
              })
            } else {
              description = erros[0]
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              })
            }
          }
          commit('toggleLoadingEmail', false)
          commit('toastrAxiosError', error)
        })
      }
    })
  },
  getCupom ({state, commit}, token) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingLogo', true)
      axios({
        method: 'get',
        url: process.url + 'Fornecedor/GetDetalheHotSite',
        timeout: 200000,
        headers: {
          'Token': token
        }
      })
      .then((response) => {
        commit('toggleLoadingLogo', false)
        commit('loadCupom', response.data.resultado)
        resolve()
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingLogo', false)
        commit('toastrAxiosError', error)
      })
    })
  }
  // cancelSchedule ({state, commit, rootGetters}) {
  //   return new Promise((resolve, reject) => {
  //     commit('toggleLoadingCanceled', true)
  //     axios({
  //       method: 'post',
  //       url: process.url + 'Agendamento/CancelSchedule',
  //       timeout: 200000,
  //       headers: {
  //         'Token': rootGetters.token
  //       },
  //       data: state.selectedSchedule
  //     })
  //     .then((response) => {
  //       commit('updateRegisteredSchedules', response.data.resultado)
  //       commit('toggleLoadingCanceled', false)
  //       commit('toggleScheduleDetailsModal', false)
  //     })
  //     .catch((error) => {
  //       commit('toastrAxiosError', error)
  //       commit('toggleLoadingCanceled', false)
  //     })
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/store/Checkin/actions.js